import React from "react";

const TopNav = () => {
  return (
    <header className="bg-gray-800 text-white shadow-md sticky top-0 z-50">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center px-6 py-4">
        <h1 className="text-2xl font-bold">App Dashboard</h1>
        <nav className="space-x-6">
          <a
            href="https://timestamp.cohere.ph/"
            className="text-white hover:text-blue-400 transition-colors"
          >
            Timerecords
          </a>
          <a
            href="https://dashboard.cohere.ph/memos/"
            className="text-white hover:text-blue-400 transition-colors"
          >
            Memo Search
          </a>
        </nav>
      </div>
    </header>
  );
};

export default TopNav;
